import { T } from "@/i18n";
import { ReactNode } from "react";

export function FieldView({
  label,
  children,
}: {
  label: string;
  children?: ReactNode;
}) {
  return (
    <div className="grid">
      <span className="text-muted-foreground">
        <T tKey={label} />
      </span>
      {children}
    </div>
  );
}
